export interface File {
  id: number;
  userId: number;
  projectId: number;
  name: string;
  uuid?: string;
  contentType: string;
  fileType: FileType;
  extension: string;
  s3url: string;
  s3path: string;
  size: number;
  isTemporary: boolean;
  createdAt: string;
  updatedAt: string;
}

export enum FileType {
  OBJECT_3D = 'OBJECT_3D',
  IES_3D = 'IES_3D',
  BAKED_3D = 'BAKED_3D',
  BAKED_IMAGE = 'BAKED_IMAGE',
  PDF_IMAGE = 'PDF_IMAGE',
  PREVIEW_IMAGE = 'PREVIEW_IMAGE',
  POINTS_MAP = 'POINTS_MAP',
  PDF_REPORT = 'PDF_REPORT',
  REPORT_IMAGE = 'REPORT_IMAGE',
}

export interface PresignedUrlResponse {
  url: string;
  size: number;
}

export interface BatchPresignedUrlResponse {
  id: number;
  url: string;
  size: number;
}

export interface DownloadProgress {
  fileId: string;
  fileName: string;
  fileType: FileType;
  totalSize: number;
  downloadedSize: number;
  isComplete: boolean;
}

export interface UploadProgress {
  totalSize: number;
  uploadedSize: number;
  isComplete: boolean;
}

export interface FileMetadataRequest {
  name: string;
  fileType: FileType;
}
